import { Lock } from './lock';

export enum MetadataCodes {
  ARCHIVE_LOCK = 'archive_lock'
}

export class Metadata {
  archive_lock?: Lock;
}
